import { useGridApiRef } from '@mui/x-data-grid-pro';
import { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  getRequestApproval,
  updatePurchaseRequestRemarks,
  verifyPurchaseRequest,
} from '../../../api/purchaseRequest';
import PrimaryDataTable from '../../../components/PrimaryDataTable';
import { getRequestDataColumn } from '../components/pendingDataColumn';
import SearchRequest from '../components/SearchProduct';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const PendingVerificationScreen = () => {
  const apiRef = useGridApiRef();
  const columns = useMemo(
    () => getRequestDataColumn(apiRef, { remarksEditable: true }),
    [apiRef],
  );

  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState('');
  const [loader, setLoader] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = (data) => {
    setRows([]);
    setSelectionModel([]);
    setLoader(true);

    getRequestApproval({
      status: 4,
      search: data,
    }).then((res) => {
      let { code, result } = res.data.response;

      if (code === '00000') {
        setRows(result);
        setLoader(false);
      }
    });
  };

  const handleSearchSubmit = () => {
    loadData(search);
  };

  const handleSearchClear = () => {
    setSearch('');
    loadData();
  };

  const handleVerify = async () => {
    if (selectionModel.length === 0) {
      toast.error('Please select at least one PR to verify');
      return;
    }

    Swal.fire({
      icon: 'question',
      title: 'Are you sure you want to verify PR?',
      showDenyButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await verifyPurchaseRequest({
          pr_hdr_id: [...selectionModel],
        });

        const { code, result } = res.data.response;

        if (code !== '00000') {
          toast.error(Array.isArray(result) ? result.join('<br />') : result);
          return;
        }

        toast.success(result);
        loadData();
      }
    });
  };

  const handleProcessRowUpdate = async (newRow) => {
    const res = await updatePurchaseRequestRemarks({
      pr_hdr_id: newRow.pr_hdr_id,
      contract_status: newRow.contract_status ?? '',
    });

    const { code, result } = res.data.response;

    if (code !== '00000') {
      const msg = Array.isArray(result) ? result.join(', ') : result;
      throw new Error(msg);
    }

    toast.success(
      typeof result === 'string' && result ? result : 'Remarks updated',
    );
    return newRow;
  };

  return (
    <>
      <Row>
        <Col sm="12 mb-3">
          {/*  */}
          <SearchRequest
            search={search}
            handleSearch={(e) => setSearch(e.target.value)}
            handleSearchSubmit={handleSearchSubmit}
            handleSearchClear={handleSearchClear}
            handleVerify={handleVerify}
            isVerify={true}
          />
        </Col>
        <Col>
          <PrimaryDataTable
            apiRef={apiRef}
            loading={loader}
            disableSelectionOnClick
            getRowId={(row) => row.pr_hdr_id}
            rows={rows}
            columns={columns}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  po_status: false, // this hides the column initially
                },
              },
            }}
            checkboxSelection
            selectionModel={selectionModel}
            onSelectionModelChange={setSelectionModel}
            experimentalFeatures={{ newEditingApi: true }}
            processRowUpdate={handleProcessRowUpdate}
            onProcessRowUpdateError={(err) => {
              toast.error(err?.message ?? 'Failed to save remarks');
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default PendingVerificationScreen;
